import { URL, UrlWithParsedQuery } from 'url';
import { parse as qsParse } from 'querystring';

export const urlFilter = (url: string): boolean =>
  !!url &&
  !url.includes('cms_page_') &&
  !url.includes('deleted') &&
  !url.includes('drafts') &&
  !url.includes('old') &&
  !url.includes('xml') &&
  !url.includes('txt') &&
  !url.includes('404') &&
  !url.includes('500') &&
  !url.includes('/content/vouchers');

export const urlMapper = (url: string): string => url.replace(/\/\//g, '/');

export const urlEncode = (url: string): string =>
  url
    .split('/')
    .map((item) => encodeURIComponent(item))
    .join('/');

export function urlParse(
  originalUrl = '',
  baseUrl = 'http://localhost:3000',
): UrlWithParsedQuery {
  const url = new URL(originalUrl, baseUrl);

  const {
    hash,
    host,
    hostname,
    href,
    pathname,
    port,
    protocol,
    search,
    searchParams,
  } = url;

  const query = qsParse(searchParams.toString());

  return {
    auth: null,
    path: null,
    slashes: null,
    hash,
    host,
    hostname,
    href,
    pathname,
    protocol,
    search,
    port,
    query,
  };
}

export default { urlFilter, urlMapper, urlEncode, urlParse };
